module.exports = __webpack_public_path__ + "2f6daa1cadee17b7416a40d57a2bd1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/bank3.png
// module id = 1080
// module chunks = 0